/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreateIndexRouteImport } from './routes/create/index'
import { Route as SignupStep2RouteImport } from './routes/signup/step2'
import { Route as SignupStep1RouteImport } from './routes/signup/step1'
import { Route as BuilderSlugRouteImport } from './routes/builder/$slug'
import { Route as BuilderSlugPreviewRouteImport } from './routes/builder/$slug.preview'
import { Route as BuilderSlugLogosRouteImport } from './routes/builder/$slug.logos'
import { Route as BuilderSlugPreviewIndexRouteImport } from './routes/builder/$slug.preview.index'
import { Route as BuilderSlugPreviewSaveRouteImport } from './routes/builder/$slug.preview.save'

const NotFoundLazyRouteImport = createFileRoute('/not-found')()
const MaintenanceLazyRouteImport = createFileRoute('/maintenance')()
const ForbiddenLazyRouteImport = createFileRoute('/forbidden')()
const OauthTestLazyRouteImport = createFileRoute('/oauth/test')()
const OauthLogoutLazyRouteImport = createFileRoute('/oauth/logout')()
const OauthCallbackLazyRouteImport = createFileRoute('/oauth/callback')()
const BuilderSlugIndexLazyRouteImport = createFileRoute('/builder/$slug/')()

const NotFoundLazyRoute = NotFoundLazyRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/not-found.lazy').then((d) => d.Route))
const MaintenanceLazyRoute = MaintenanceLazyRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/maintenance.lazy').then((d) => d.Route))
const ForbiddenLazyRoute = ForbiddenLazyRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/forbidden.lazy').then((d) => d.Route))
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/create/index.lazy').then((d) => d.Route))
const OauthTestLazyRoute = OauthTestLazyRouteImport.update({
  id: '/oauth/test',
  path: '/oauth/test',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/oauth/test.lazy').then((d) => d.Route))
const OauthLogoutLazyRoute = OauthLogoutLazyRouteImport.update({
  id: '/oauth/logout',
  path: '/oauth/logout',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/oauth/logout.lazy').then((d) => d.Route))
const OauthCallbackLazyRoute = OauthCallbackLazyRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/oauth/callback.lazy').then((d) => d.Route),
)
const SignupStep2Route = SignupStep2RouteImport.update({
  id: '/step2',
  path: '/step2',
  getParentRoute: () => SignupRoute,
} as any)
const SignupStep1Route = SignupStep1RouteImport.update({
  id: '/step1',
  path: '/step1',
  getParentRoute: () => SignupRoute,
} as any)
const BuilderSlugRoute = BuilderSlugRouteImport.update({
  id: '/builder/$slug',
  path: '/builder/$slug',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/builder/$slug.lazy').then((d) => d.Route))
const BuilderSlugIndexLazyRoute = BuilderSlugIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuilderSlugRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.index.lazy').then((d) => d.Route),
)
const BuilderSlugPreviewRoute = BuilderSlugPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => BuilderSlugRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.preview.lazy').then((d) => d.Route),
)
const BuilderSlugLogosRoute = BuilderSlugLogosRouteImport.update({
  id: '/logos',
  path: '/logos',
  getParentRoute: () => BuilderSlugRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.logos.lazy').then((d) => d.Route),
)
const BuilderSlugPreviewIndexRoute = BuilderSlugPreviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuilderSlugPreviewRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.preview.index.lazy').then((d) => d.Route),
)
const BuilderSlugPreviewSaveRoute = BuilderSlugPreviewSaveRouteImport.update({
  id: '/save',
  path: '/save',
  getParentRoute: () => BuilderSlugPreviewRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.preview.save.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/builder/$slug': typeof BuilderSlugRouteWithChildren
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRoute
  '/builder/$slug/preview': typeof BuilderSlugPreviewRouteWithChildren
  '/builder/$slug/': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/preview/save': typeof BuilderSlugPreviewSaveRoute
  '/builder/$slug/preview/': typeof BuilderSlugPreviewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRoute
  '/builder/$slug': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/preview/save': typeof BuilderSlugPreviewSaveRoute
  '/builder/$slug/preview': typeof BuilderSlugPreviewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/builder/$slug': typeof BuilderSlugRouteWithChildren
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create/': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRoute
  '/builder/$slug/preview': typeof BuilderSlugPreviewRouteWithChildren
  '/builder/$slug/': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/preview/save': typeof BuilderSlugPreviewSaveRoute
  '/builder/$slug/preview/': typeof BuilderSlugPreviewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/builder/$slug'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create'
    | '/builder/$slug/logos'
    | '/builder/$slug/preview'
    | '/builder/$slug/'
    | '/builder/$slug/preview/save'
    | '/builder/$slug/preview/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create'
    | '/builder/$slug/logos'
    | '/builder/$slug'
    | '/builder/$slug/preview/save'
    | '/builder/$slug/preview'
  id:
    | '__root__'
    | '/'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/builder/$slug'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create/'
    | '/builder/$slug/logos'
    | '/builder/$slug/preview'
    | '/builder/$slug/'
    | '/builder/$slug/preview/save'
    | '/builder/$slug/preview/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SignupRoute: typeof SignupRouteWithChildren
  ForbiddenLazyRoute: typeof ForbiddenLazyRoute
  MaintenanceLazyRoute: typeof MaintenanceLazyRoute
  NotFoundLazyRoute: typeof NotFoundLazyRoute
  BuilderSlugRoute: typeof BuilderSlugRouteWithChildren
  OauthCallbackLazyRoute: typeof OauthCallbackLazyRoute
  OauthLogoutLazyRoute: typeof OauthLogoutLazyRoute
  OauthTestLazyRoute: typeof OauthTestLazyRoute
  CreateIndexRoute: typeof CreateIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/test': {
      id: '/oauth/test'
      path: '/oauth/test'
      fullPath: '/oauth/test'
      preLoaderRoute: typeof OauthTestLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/logout': {
      id: '/oauth/logout'
      path: '/oauth/logout'
      fullPath: '/oauth/logout'
      preLoaderRoute: typeof OauthLogoutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/step2': {
      id: '/signup/step2'
      path: '/step2'
      fullPath: '/signup/step2'
      preLoaderRoute: typeof SignupStep2RouteImport
      parentRoute: typeof SignupRoute
    }
    '/signup/step1': {
      id: '/signup/step1'
      path: '/step1'
      fullPath: '/signup/step1'
      preLoaderRoute: typeof SignupStep1RouteImport
      parentRoute: typeof SignupRoute
    }
    '/builder/$slug': {
      id: '/builder/$slug'
      path: '/builder/$slug'
      fullPath: '/builder/$slug'
      preLoaderRoute: typeof BuilderSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder/$slug/': {
      id: '/builder/$slug/'
      path: '/'
      fullPath: '/builder/$slug/'
      preLoaderRoute: typeof BuilderSlugIndexLazyRouteImport
      parentRoute: typeof BuilderSlugRoute
    }
    '/builder/$slug/preview': {
      id: '/builder/$slug/preview'
      path: '/preview'
      fullPath: '/builder/$slug/preview'
      preLoaderRoute: typeof BuilderSlugPreviewRouteImport
      parentRoute: typeof BuilderSlugRoute
    }
    '/builder/$slug/logos': {
      id: '/builder/$slug/logos'
      path: '/logos'
      fullPath: '/builder/$slug/logos'
      preLoaderRoute: typeof BuilderSlugLogosRouteImport
      parentRoute: typeof BuilderSlugRoute
    }
    '/builder/$slug/preview/': {
      id: '/builder/$slug/preview/'
      path: '/'
      fullPath: '/builder/$slug/preview/'
      preLoaderRoute: typeof BuilderSlugPreviewIndexRouteImport
      parentRoute: typeof BuilderSlugPreviewRoute
    }
    '/builder/$slug/preview/save': {
      id: '/builder/$slug/preview/save'
      path: '/save'
      fullPath: '/builder/$slug/preview/save'
      preLoaderRoute: typeof BuilderSlugPreviewSaveRouteImport
      parentRoute: typeof BuilderSlugPreviewRoute
    }
  }
}

interface SignupRouteChildren {
  SignupStep1Route: typeof SignupStep1Route
  SignupStep2Route: typeof SignupStep2Route
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupStep1Route: SignupStep1Route,
  SignupStep2Route: SignupStep2Route,
}

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren)

interface BuilderSlugPreviewRouteChildren {
  BuilderSlugPreviewSaveRoute: typeof BuilderSlugPreviewSaveRoute
  BuilderSlugPreviewIndexRoute: typeof BuilderSlugPreviewIndexRoute
}

const BuilderSlugPreviewRouteChildren: BuilderSlugPreviewRouteChildren = {
  BuilderSlugPreviewSaveRoute: BuilderSlugPreviewSaveRoute,
  BuilderSlugPreviewIndexRoute: BuilderSlugPreviewIndexRoute,
}

const BuilderSlugPreviewRouteWithChildren =
  BuilderSlugPreviewRoute._addFileChildren(BuilderSlugPreviewRouteChildren)

interface BuilderSlugRouteChildren {
  BuilderSlugLogosRoute: typeof BuilderSlugLogosRoute
  BuilderSlugPreviewRoute: typeof BuilderSlugPreviewRouteWithChildren
  BuilderSlugIndexLazyRoute: typeof BuilderSlugIndexLazyRoute
}

const BuilderSlugRouteChildren: BuilderSlugRouteChildren = {
  BuilderSlugLogosRoute: BuilderSlugLogosRoute,
  BuilderSlugPreviewRoute: BuilderSlugPreviewRouteWithChildren,
  BuilderSlugIndexLazyRoute: BuilderSlugIndexLazyRoute,
}

const BuilderSlugRouteWithChildren = BuilderSlugRoute._addFileChildren(
  BuilderSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SignupRoute: SignupRouteWithChildren,
  ForbiddenLazyRoute: ForbiddenLazyRoute,
  MaintenanceLazyRoute: MaintenanceLazyRoute,
  NotFoundLazyRoute: NotFoundLazyRoute,
  BuilderSlugRoute: BuilderSlugRouteWithChildren,
  OauthCallbackLazyRoute: OauthCallbackLazyRoute,
  OauthLogoutLazyRoute: OauthLogoutLazyRoute,
  OauthTestLazyRoute: OauthTestLazyRoute,
  CreateIndexRoute: CreateIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
